try {
  console.debug('Pro Gallery Version: 1.5.31');
} catch (e) {}